module.exports = __webpack_public_path__ + "img/zuijia_35.93e74a98.png";